import React from 'react'
import './ContextMenu.css';
import Icon from '../home/Icon';
import { useContextMenu } from '../context/ContextMenuContext';

function ContextMenuItem({ icon, label, type, onClick, disabled = false, disabledHint = 'Offline nicht verfügbar' }) {
  const { closeContextMenu } = useContextMenu();

  const handleMenuItemClick = (event) => {
    if (disabled) return;
    closeContextMenu();
    onClick(event);
  };

  const colorClass = disabled
    ? 'disabled'
    : type === 1 ? 'negative'
    : type === 2 ? 'positive'
    : type === 3 ? 'accent'
    : '';

  return (
    <li className={`contextMenuItem ${colorClass}`}
      onClick={handleMenuItemClick}
      title={disabled ? disabledHint : undefined}>
      <Icon className={"contextMenuIcon"} icon={icon} />
      <p className={"contextMenuText"}>{label}</p>
    </li>
  )
}

export default ContextMenuItem